import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import XRegExp from "xregexp";
import { RfrStepProps } from "../../../pages/FileRFR/RfRForm";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import RfrInput from "./RfrInput";
import RfrInputName from "./RfrInputName";
import RfrInputPhone from "./RfrInputPhone";

import "./Steps.css";

export default function Step2(props: RfrStepProps) {
    const { t } = useTranslation("rfr");
    const formdata = props.formdata;
    const user_prop = props.statedata.user_prop;
    const [stepdata, setStepdata] = useState({
        step21ValueInput: "step21ValueInput" in formdata ? formdata["step21ValueInput"] : user_prop.cva,
        step22OwnerNameInputFirst: "step22OwnerNameInputFirst" in formdata ? formdata["step22OwnerNameInputFirst"] : "",
        step22OwnerNameInputLast: "step22OwnerNameInputLast" in formdata ? formdata["step22OwnerNameInputLast"] : "",
        step22OwnerPhoneInput: "step22OwnerPhoneInput" in formdata ? formdata["step22OwnerPhoneInput"] : "",
        step22OwnerPhoneInputExt: "step22OwnerPhoneInputExt" in formdata ? formdata["step22OwnerPhoneInputExt"] : "",
        step22OwnerAltPhoneInput: "step22OwnerAltPhoneInput" in formdata ? formdata["step22OwnerAltPhoneInput"] : "",
        step22OwnerAltPhoneInputExt: "step22OwnerAltPhoneInputExt" in formdata ? formdata["step22OwnerAltPhoneInputExt"] : "",
        altAddress: "altAddress" in formdata ? formdata["altAddress"] : "NO",
        step23AddressInput: "step23AddressInput" in formdata ? formdata["step23AddressInput"] : ""
    });

    const [errors, setErrors] = useState({
        step21ValueInput: "",
        step22OwnerNameInput: "",
        step22OwnerPhoneInput: "",
        step22OwnerAltPhoneInput: "",
        step23AddressInput: ""
    });

    const clearErrors = () => {
        Object.keys(errors).forEach((err) => {
            errors[err] = "";
        });
        setErrors(prevState => ({
            ...prevState,
            ...errors
        }));
    }

    const clearStepdata = (e) => {
        e.preventDefault();
        clearErrors();
        Object.keys(stepdata).forEach((key) => {
            stepdata[key] = "";
        });
        stepdata["step21ValueInput"] = user_prop.cva;
        stepdata["altAddress"] = "NO";
        setStepdata(prevState => ({
            ...prevState,
            ...stepdata
        }));
    }

    const trimData = () => {
        Object.keys(stepdata).forEach((key) => {
            const value = stepdata[key];
            if (typeof value === "string") {
                stepdata[key] = value.trim();
            }
        });
        setStepdata(prevState => ({
            ...prevState,
            ...stepdata
        }));
    }

    const setData = (name: string, value: string) => {
        stepdata[name] = value;
        setStepdata(prevState => ({
            ...prevState,
            ...stepdata
        }));
    }

    const handleInputData = (event) => {
        const { name, value } = event.target;
        setData(name, value);
    }

    const handleCheckboxInput = (event) => {
        const { name, value } = event.target;
        if (stepdata[name] !== value) {
            setData(name, value);
        }
    }

    const validate = () => {
        clearErrors();
        trimData();

        let valid = true;

        if (stepdata["step21ValueInput"] === "") {
            valid = false;
            errors["step21ValueInput"] = t("rfr.rfrform.step2.error-value-required");
        }
        const valueregexp = XRegExp("^[0-9]*$", "i");
        if (valueregexp.test(stepdata["step21ValueInput"].replace(/[^0-9]/g, '')) === false) {
            valid = false;
            errors["step21ValueInput"] = t("rfr.rfrform.step2.error-value-format");
        }

        const regexp = XRegExp("^[\\p{L}\\p{N}]([.',-]?[\\p{L}\\p{N} ])*([.\\p{L}\\p{N}])?$", "i");
        if (stepdata["step22OwnerNameInputFirst"] === "" || stepdata["step22OwnerNameInputLast"] === "") {
            valid = false;
            errors["step22OwnerNameInput"] = t("rfr.rfrform.error-name");
        } else {
            if (regexp.test(stepdata["step22OwnerNameInputFirst"]) === false || regexp.test(stepdata["step22OwnerNameInputLast"]) === false) {
                valid = false;
                errors["step22OwnerNameInput"] = t("rfr.rfrform.error-name");
            }
        }

        const phone = stepdata["step22OwnerPhoneInput"];
        if (phone === "" || phone.length < 10) {
            valid = false;
            errors["step22OwnerPhoneInput"] = t("rfr.rfrform.error-phone");
        }

        const altphone = stepdata["step22OwnerAltPhoneInput"];
        if (altphone !== "" && (altphone.length > 0 && altphone.length < 10)) {
            valid = false;
            errors["step22OwnerAltPhoneInput"] = t("rfr.rfrform.error-phone");
        }

        if (stepdata.altAddress === "YES" && stepdata.step23AddressInput === "") {
            valid = false;
            errors["step23AddressInput"] = t("rfr.rfrform.step2.error-mailing");
        }

        setErrors(errors);
        return valid;
    }

    const findFirstError = () => {
        let firstError = null;
        Object.keys(errors).forEach((err) => {
            if (errors[err] !== "" && firstError === null) {
                let elems = document.getElementsByName(err);
                if (elems === null || elems === undefined || elems.length === 0) {
                    elems = document.getElementsByName(err + "First");
                }
               if (elems !== null && elems !== undefined && elems.length > 0) {
                    firstError = elems[0];
                }
            }
        });
        return firstError;
    }

    const handleNext = (e) => {
        const valid = validate();
        if (!valid) {
            const firstError = findFirstError();
            if (firstError !== null && firstError !== undefined) {
                firstError.scrollIntoView({ behavior: "smooth", block: "start" });
            }
            e.preventDefault();
            return;
        }
        props.handleStepChange("step3", stepdata, null, "");
    }

    const handleBack = (e) => {
        e.preventDefault();
        props.handleStepChange("step1", stepdata, null, "");
    }

    const formatRoll = () => {
        const roll = props.statedata.user_prop.roll_num;
        return roll.substring(0, 2) + " " + roll.substring(2, 4) + " " + roll.substring(4, 7) + " " + roll.substring(7, 10) + " " + roll.substring(10, 15) + " " + roll.substring(15, 19);
    }

    return (
        <div>
            <div className="tab-title font_size_13">
                {t("rfr.rfrform.step2.tab-title")}
            </div>
            <div className="form_body">
                <div className="rfr-form-blue-row">
                    {t("rfr.rfrform.step2.property-details")} ( * {t("rfr.rfrform.required")})
                </div>
                <RfrInput label={t("rfr.rfrform.step2.desc-roll-number")} name="step21RollInput" type="text" required={false} value={formatRoll()} disabled={true} />
                <RfrInput label={t("rfr.rfrform.step2.desc-assessed-value")} name="step21ValueInput" type="number" required={true} value={stepdata.step21ValueInput} onInput={handleInputData} />
                <AmpFormError error={errors["step21ValueInput"] !== ""} errorMessage={t("rfr.rfrform.step2.error-value-required")} />
                <RfrInput label={t("rfr.rfrform.step2.desc-property-address")} name="step21PropAddressInput" type="text" required={false} value={formdata["step21PropAddressInput"]} disabled={true} />
                <RfrInput label={t("rfr.rfrform.step2.desc-municipality")} name="step21MunicipalityInput" type="text" required={false} value={formdata["step21MunicipalityInput"]} disabled={true} />
                <div className="rfr-form-blue-row">
                    {t("rfr.rfrform.step2.personal-details")} ( * {t("rfr.rfrform.required")})
                </div>
                <RfrInputName label={t("rfr.rfrform.step2.desc-property-owner")} name="step22OwnerNameInput" required={true} placeholderfirst={t("rfr.rfrform.firstname")} placeholderlast={t("rfr.rfrform.lastname")} data={stepdata} onInput={handleInputData} />
                <AmpFormError error={errors["step22OwnerNameInput"] !== ""} errorMessage={t("rfr.rfrform.error-name")} />
                <RfrInputPhone label={t("rfr.rfrform.phonenumber")} name="step22OwnerPhoneInput" required={true} data={stepdata} onInput={handleInputData} />
                <AmpFormError error={errors["step22OwnerPhoneInput"] !== ""} errorMessage={t("rfr.rfrform.error-phone")} />
                <RfrInputPhone label={t("rfr.rfrform.phonenumber")} name="step22OwnerAltPhoneInput" required={false} data={stepdata} onInput={handleInputData} />
                <AmpFormError error={errors["step22OwnerAltPhoneInput"] !== ""} errorMessage={t("rfr.rfrform.error-phone")} />
                <RfrInput label={t("rfr.rfrform.emailaddress")} name="step22OwnerEmailInput" type="text" required={false} disabled={true} value={formdata["step22OwnerEmailInput"]} />
                <div className="rfr-form-blue-row">
                    {t("rfr.rfrform.step2.mailing-address")} ( * {t("rfr.rfrform.required")})
                    <p>
                        {t("rfr.rfrform.step2.mailing-address-desc")}
                    </p>
                </div>
                <div className="rfr-form-description">
                    <p className="font-blue">* {t("rfr.rfrform.step2.desc-altaddress")}</p>
                    <div className="font-blue rfr-form-row">
                        <div className="rfr-form-row-checkbox-small">
                            <div>
                                <span>
                                    <input id="altAddress_NO" name="altAddress" type="checkbox" onChange={(e) => handleCheckboxInput(e)} value="NO" checked={stepdata["altAddress"] === "NO" ? true : false} />
                                    <label htmlFor="altAddress_NO">{t("rfr.rfrform.NO")}</label>
                                </span>
                            </div>
                        </div>
                        <div className="rfr-form-row-checkbox-small">
                            <div>
                                <span>
                                    <input id="altAddress_YES" name="altAddress" type="checkbox" onChange={(e) => handleCheckboxInput(e)} value="YES" checked={stepdata["altAddress"] === "YES" ? true : false} />
                                    <label htmlFor="altAddress_YES">{t("rfr.rfrform.YES")}</label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    stepdata["altAddress"] === "NO" ?
                        (
                            <div id="altAddressNoDiv" className="rfr-form-cont">
                            </div>
                        )
                        :
                        (
                            <div id="altAddressYesDiv" className="rfr-form-cont">
                                <div className="rfr-form-cont padding-bottom">
                                    <div className="rfr-form-row">
                                        <div className="rfr-form-row-textarea">
                                            <textarea onChange={(e) => handleInputData(e)} value={stepdata.step23AddressInput} name="step23AddressInput" id="step23AddressInput" rows={8} className="width-100" title={t("rfr.rfrform.step2.title-altaddress")}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <AmpFormError error={errors["step23AddressInput"] !== ""} errorMessage={t("rfr.rfrform.step2.error-mailing")} />
                            </div>
                        )
                }
            </div>
            <div className="box_footer">
                <div>
                    <Link className="need-help-btn amp-anchor" to="/amp/contact-us" target="_blank" rel="noreferrer noopener">
                        {t("rfr.rfrform.needhelp")}
                    </Link>
                </div>
                <div>
                    <AmpButton onClick={(e) => clearStepdata(e)} text={t("rfr.rfrform.clear")} type="cancel" />
                    <AmpButton onClick={(e) => handleBack(e)} text={t("rfr.rfrform.back")} type={"cancel"} />
                    <AmpButton onClick={(e) => handleNext(e)} text={t("rfr.rfrform.next")} type={"submit"} />
                </div>
            </div>
        </div>
    );
}